import Item from '@/framework/base/classes/Item';
import { FieldStatus } from '@/framework/base/components/FieldInfo';
import FractionDsnGenre from '@/generated/controls/fractionDsn/FractionDsnGenre.vue';
import { defineComponent } from "vue";
import { storeFractionDsn, storeEtablissement } from '@/generated/stores';
import { FractionDsnGenres, FractionDsnTypes } from '@/generated/classes/FractionDsn';
import Societe from '@/generated/classes/Societe';

export default defineComponent({
  components: {},
  extends: FractionDsnGenre,
  data() {
    const items: Item[] = [
      { "key": 2, "title": "Service interne de paie" },
      { "key": 3, "title": "Prestataire de paie" }
    ];
    return {
      initValue: 0,
      lastContextId: 0,
      status: new FieldStatus(false, false, 0),
      items
    }
  },
  mounted(): void {
    const fraction = storeFractionDsn.getFractionDsn(this.contextId);
    const hasFraction = storeFractionDsn.listFractionDsn.find(a =>
      a.etablissementId == fraction.etablissementId &&
      a.type != FractionDsnTypes.NONE) != undefined;
    const teseCea = storeFractionDsn.listFractionDsn.find(a =>
      a.etablissementId == fraction.etablissementId &&
      a.genre == FractionDsnGenres.TESE_CEA) != undefined;
    if (hasFraction && (!teseCea || fraction.genre == FractionDsnGenres.TESE_CEA)) {
      const etablissement = storeEtablissement.getEtablissement(fraction.etablissementId);
      Societe.get(etablissement.societeId).then((res) => {
        if (res.association) {
          this.items.push(new Item(4, "Service CEA"));
        } else {
          this.items.push(new Item(4, "Service TESE"));
        }
      })
    }
  },
  computed: {
    display(): string {
      this.changeContext();
      let agetaValue = this.value;
      if (agetaValue == 1) {
        agetaValue = 3;
      }
      const item = Item.fromValue(this.items, agetaValue);
      return item.title;
    }
  }
})


